import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UpdateUserProfileRequest, UserProfile } from '../models/user-profile';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private http = inject(HttpClient);

  getUserProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${environment.apiUrl}/me/profile`);
  }

  updateUserProfile(profile: UpdateUserProfileRequest): Observable<UserProfile> {
    return this.http.patch<UserProfile>(`${environment.apiUrl}/me/profile`, profile);
  }

  deleteUser(): Observable<UserProfile> {
    return this.http.delete<UserProfile>(`${environment.apiUrl}/me/profile`);
  }
}
